<script lang="ts">
	//UI
	import { SetupIcon, InlineButton } from "@hitit/new_ui";
	//Utils
	import { createEventDispatcher } from "svelte";
	//Types
	//Props
	export let category: { name: string; getLength: () => number };
	export let editmode = false;
	export let editable = false;
	export let hasSetup = false;
	//Constants
	const dispatch = createEventDispatcher();
	//Variables
	//Functions
	function setupClickEvent() {
		dispatch("SETUP_CATEGORY_REQUEST", category);
	}
	//Do

</script>

<div class="controler-name">
	{#if editmode && editable}
		<div class="setupicon">
			<InlineButton on:click={setupClickEvent}>
				<div id="setupbutton">
					<SetupIcon fill={hasSetup ? '#6d6f76' : '#bcbfc3'} />
				</div>
			</InlineButton>
			<slot name="setup" />
		</div>
	{/if}
	<div class="name">{category.name}({category.getLength()})</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.controler-name {
		display: flex;
		gap: 10px;
		align-items: center;

		.name {
			display: flex;
			align-items: center;
			word-break: break-all;

			font-weight: 500;
			font-size: 1.25rem;
			color: #46474b;
			margin-top: -2px;
		}
		.setupicon {
			position: relative;
		}

		.setupicon {
			width: 30px;
			height: 30px;

			&:hover {
				cursor: pointer;
			}
		}
	}
	@include DesktopSize {
		.controler-name {
			.name {
				font-size: 2rem;
				font-weight: 600;
			}
			.setupicon {
				width: 36px;
				height: 36px;
			}
		}
	}

</style>
